var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { apiOMM } from '../axios-client';
import { getHost } from '../../utils/general';
import { OMM_EDIT_DELIVERY_ADDRESS_CREATE_CART, OMM_EDIT_DELIVERY_ADDRESS_VALIDATE_ADDRESS, OMM_EDIT_DELIVERY_ADDRESS_UPDATE_ADDRESS, OMM_EDIT_DELIVERY_ADDRESS_SUSPEND_CART, OMM_EDIT_DELIVERY_ADDRESS_GET_CITIES_BY_ZIPCODE, } from '../../constants/paths';
var baseurl = getHost();
export var SubmitValidateDeliveryAddress = function (requestData, isValidated, setSubmitCreateForm, setDrawerError, fulfillmentGroupIndex, setIsValidated, closeDrawer, setIsLoading, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        return [2 /*return*/, apiOMM
                .post(OMM_EDIT_DELIVERY_ADDRESS_VALIDATE_ADDRESS, requestData, {
                headers: headers,
                baseURL: baseurl,
            })
                .then(function (res) {
                // handles the first button click, if the address is successfully recognized
                if (res.data.data.valid === true) {
                    setSubmitCreateForm(true, res.data.data.et);
                    setIsValidated(null, true);
                    // handles the second button click, trying to validate a non-verifiable address. It will always submit even if not recognized on second attempt
                }
                else if (isValidated.firstTry === false &&
                    isValidated.valid === false) {
                    setSubmitCreateForm(true, res.data.data.et);
                    setIsValidated(null, null);
                    // handles the first button click, if the address is not a recognized address
                }
                else {
                    setIsValidated(false, false);
                    setIsLoading(false);
                }
            })
                .catch(function () {
                closeDrawer();
                setDrawerError(fulfillmentGroupIndex);
                setIsLoading(false);
            })];
    });
}); };
export var SubmitDeliveryAddressCreateCart = function (requestData, setIsChangeForm, setIsConfirmation, setIsLoading, setDrawerError, setIsExcludedAddress, fulfillmentGroupIndex, closeDrawer, setUpdatedAddressData, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        return [2 /*return*/, apiOMM
                .post(OMM_EDIT_DELIVERY_ADDRESS_CREATE_CART, requestData, {
                headers: headers,
                baseURL: baseurl,
            })
                .then(function (res) {
                setIsChangeForm(false);
                setIsConfirmation(true);
                setUpdatedAddressData({ ordersInfo: res.data });
            })
                .catch(function (err) {
                var errorCode = err.response.data.errors[0].code;
                if (errorCode === '8.400.27') {
                    setIsExcludedAddress(true);
                    return;
                }
                setDrawerError(fulfillmentGroupIndex);
                closeDrawer();
            })
                .finally(function () {
                setIsLoading(false);
            })];
    });
}); };
export var SubmitDeliveryAddressUpdateAddress = function (requestData, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        return [2 /*return*/, apiOMM.post(OMM_EDIT_DELIVERY_ADDRESS_UPDATE_ADDRESS, requestData, {
                headers: headers,
                baseURL: baseurl,
            })];
    });
}); };
export var SubmitDeliveryAddressSuspendCart = function (requestData, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        return [2 /*return*/, apiOMM.post(OMM_EDIT_DELIVERY_ADDRESS_SUSPEND_CART, requestData, {
                headers: headers,
                baseURL: baseurl,
            })];
    });
}); };
export var SubmitDeliveryAddressGetCitiesByZipCode = function (requestData, setGetCitiesByZipCode, setIsLoading, setIsChangeForm, setDrawerError, fulfillmentGroupIndex, traceId, setOpen) {
    var headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
    if (process.env.NODE_ENV === 'development') {
        headers['true-client-ip'] = '192.168.1.19';
    }
    return apiOMM
        .post(OMM_EDIT_DELIVERY_ADDRESS_GET_CITIES_BY_ZIPCODE, requestData, {
        headers: headers,
        baseURL: baseurl,
    })
        .then(function (response) {
        var _a, _b;
        setGetCitiesByZipCode((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.cities);
        setIsChangeForm(true);
        if (setOpen) {
            setOpen(true);
        }
    })
        .catch(function () {
        setDrawerError(fulfillmentGroupIndex);
    })
        .finally(function () {
        setIsLoading(false);
    });
};
